import type { MessageKey } from '../i18n/en';
import { en } from '../i18n/en';

/** Ошибка API в формате `{ error: { code, message, details? } }` (AGENTS.md §10). */
export class ApiError extends Error {
  override readonly name = 'ApiError';

  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
  }
}

interface ApiErrorBody {
  error?: { code?: unknown; message?: unknown; details?: unknown };
}

/** Превращает ответ openapi-fetch в данные или ApiError. */
export function unwrap<T>(result: { data?: T; error?: unknown; response: Response }): T {
  if (result.error !== undefined || result.data === undefined) {
    const body = (result.error ?? {}) as ApiErrorBody;
    const code = typeof body.error?.code === 'string' ? body.error.code : 'UNKNOWN';
    const message =
      typeof body.error?.message === 'string' ? body.error.message : result.response.statusText;
    throw new ApiError(result.response.status, code, message, body.error?.details);
  }
  return result.data;
}

/** Ключ словаря для кода ошибки; неизвестный код — общий текст. Сервер текстов не переводит. */
export function errorMessageKey(error: unknown): MessageKey {
  if (error instanceof ApiError) return errorKeyFromCode(error.code);
  if (error instanceof TypeError) return 'error.NETWORK';
  return 'error.UNKNOWN';
}

/** То же для кода без ответа API — например, `?error=CODE` после возврата с Google. */
export function errorKeyFromCode(code: string): MessageKey {
  const key = `error.${code}`;
  return key in en ? (key as MessageKey) : 'error.UNKNOWN';
}
